<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half1">THE</p>
<p class="half"><span class="bold">SINKING</span></p>
<p class="half2">OF THE</p>
<p class="halfa"><span class="bold">BLÜCHER</span></p>
<div class="img_container" id="pgiimg1">
<img alt="images" src="images/f000i-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?a4561de6